module.exports = __webpack_public_path__ + "img/info-rounded.d4f299d3.svg";